@use 'sass:math';
@use '../../../scss/utility';

:host([allow-overflow-x]) {
  overflow-x: visible;
}

:host([scroll-overflow-x]) {
  overflow-x: scroll;
}

:host([auto-overflow]) {
  overflow: auto;
}

@mixin wb-grid-styles-for-mq($mq) {
  // to reset the grid flow if a start-col wsed before
  :host([start-col-#{$mq}='auto']) {
    grid-column-start: auto;
  }

  @for $i from 1 through utility.$wb-grid-column-amount {
    :host([start-col-#{$mq}='#{$i}']) {
      grid-column-start: $i;
    }

    :host([#{$mq}='hide']) {
      display: none; // to have a collapsing grid item if needed for offset
    }

    :host([#{$mq}='#{$i}']) {
      display: unset; // to reset the display to the inherited value of `display: grid;`
      grid-column-end: span $i;
    }
  }
}

@each $mq in map-keys(utility.$wb-breakpoints) {
  @if ($mq == mq1) {
    @include wb-grid-styles-for-mq($mq);
  } @else {
    @include utility.breakpoint-from($mq) {
      @include wb-grid-styles-for-mq($mq);
    }
  }
}
